/* Common Imports */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";

/* Component Imports */
import AppConfig from "../../../../AppConfig";
import { Link } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  gridCardContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    /* XXS breakpoint */
    [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
      width: "100%",
      height: "16rem",
      margin: "0rem 0% 0rem 0%",
    },
    [theme.breakpoints.only("xs")]: {
      width: "100%",
      height: "20rem",
      margin: "0.5rem 0% 0.5rem 0%",
    },
    /* XSSM breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.sm - 60)]: {
      width: "49%",
      height: "15rem",
      margin: "0.5rem 0.5% 0.5rem 0.5%",
    },
    [theme.breakpoints.only("sm")]: {
      width: "49%",
      height: "20rem",
      margin: "0.5rem 0.25% 0.5rem 0.25%",
    },
    [theme.breakpoints.only("md")]: {
      width: "32.33%",
      height: "20rem",
      margin: "0.5rem 0.167% 0.5rem 0.167%",
    },
    [theme.breakpoints.only("lg")]: {
      width: "20%",
      height: "15rem",
    },
    [theme.breakpoints.only("xl")]: {
      width: "20%",
      height: "15rem",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      width: "32.33%",
      height: "29rem",
      margin: "0.5rem 0.167% 0.5rem 0.167%",
    },
    /* XXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 1920)]: {
      width: "32.33%",
      height: "32rem",
      margin: "0.5rem 0.167% 0.5rem 0.167%",
    },
    borderRadius: "4px",
    boxShadow:
      "0px 0px 2px rgb(0 0 0 / 14%), 0px 2px 2px rgb(0 0 0 / 12%), 0px 1px 3px rgb(0 0 0 / 20%)",
    color: "#202020",
    "&:hover": {
      textDecoration: "none",
    },
  },
  gridCardInfoContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: "rem 1rem 0.5rem 1rem",
    width: "100%",
    height: "100%",
    borderRadius: "4px",
  },
  ImageContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    width: "48%",
    height: "20rem",
    borderRadius: "4px",
    padding: "1rem 1rem 0rem 1rem",
  },
  gridCardImage: {
    width: "100%",
    height: "auto",
    borderRadius: "4px",
  },
  propertyTitle: {
    fontWeight: 600,
    fontSize: "1rem",
    lineHeight: "1.5rem",
    padding: "1rem 0rem 1rem 0rem",
  },
}));

const DownloadCard = (props) => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <Link
        href={
          props.href
            ? AppConfig.apiUrlPrefix +
              "download-image?imageUrl=" +
              encodeURIComponent(props.href) +
              "&fileName=" +
              encodeURIComponent(props.title ? props.title : "Customer")
            : encodeURIComponent(
                AppConfig.apiUrlPrefix +
                  "download-image?imageUrl=https://bucket.beegru.in/customer.png&fileName=Customer",
              )
        }
        rel="noopener"
        title={props.title ? props.title : "Unknown Property"}
        download={props.title ? props.title : "Unknown Property"}
        className={classes.gridCardContainer}
      >
        <div className={classes.ImageContainer}>
          <img
            src={
              props.imageSrc
                ? props.imageSrc
                : "/images/other/placeholder_1080p.jpg"
            }
            alt={AppConfig.imageAltText}
            loading="lazy"
            referrerPolicy="no-referrer"
            className={classes.gridCardImage}
          />
        </div>
        <Typography
          variant="body2"
          component="span"
          className={classes.propertyTitle}
        >
          {props.title ? props.title : "Untitled Property"}
        </Typography>
      </Link>
    </React.Fragment>
  );
};

export default DownloadCard;
